/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerRevokeOwnSessionsMutationResponse } from "../../models/usersController/UserControllerRevokeOwnSessions";

function getUserControllerRevokeOwnSessionsUrl() {
  const res = { method: 'POST', url: `/api/v1/users/me/sessions/revoke` as const }  
  return res
}

/**
 * @summary Sign out of every session for the current user
 * {@link /api/v1/users/me/sessions/revoke}
 */
export async function userControllerRevokeOwnSessions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UserControllerRevokeOwnSessionsMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getUserControllerRevokeOwnSessionsUrl().url.toString(), ... requestConfig })  
  return res.data
}